import { createContext, useContext } from "react";
var defaultContext = {
  type: "info"
};
var BannerContext = /*#__PURE__*/createContext(defaultContext);
export var BannerContextProvider = BannerContext.Provider;
export var useBannerContext = function useBannerContext() {
  return useContext(BannerContext);
};
//# sourceMappingURL=BannerContext.js.map